module.exports = __webpack_public_path__ + "static/media/download-docs.c6c8860d.svg";